import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('framework-data-table');
export const FDT_METRIC_NAMES = {
  ROW_UPDATE_TO_ALL_LABEL_CELLS_VISIBLE_TIME: 'ROW_UPDATE_TO_ALL_LABEL_CELLS_VISIBLE_TIME',
  TBODY_MOUNT_TO_ALL_LABEL_CELLS_VISIBLE_TIME: 'TBODY_MOUNT_TO_ALL_LABEL_CELLS_VISIBLE_TIME'
};